<template>
  <BaseButton
    v-show="!appUserIsGuest"
    :class="$style.button"
    :type="buttonType"
    small
    :outlined="!storeMode"
    :loading="loading"
    @click.native="toggleStoreMode()"
  >
    <IconSelect class="mr-2" icon="store" height="18" width="18" />

    <div :class="$style['switch-wrapper']">
      <span v-show="storeMode" :class="statusClasses">{{ $t('app.store_mode.on') }}</span>

      <v-switch
        v-model="storeMode"
        :class="$style.switch"
        flat
        dense
        hide-details
        :ripple="false"
      ></v-switch>

      <span v-show="!storeMode" :class="statusClasses">{{ $t('app.store_mode.off') }}</span>
    </div>
  </BaseButton>
</template>

<script>
import axios from '@/js/helper/axios-helper.js'
import { get } from 'lodash-es'
import { mapGetters } from 'vuex'

import API_CONSTANTS from '@/js/helper/api-constants.js'
import IconSelect from '@/js/components/Shared/IconSelect/IconSelect.vue'

import NAV_CONSTANTS from '@/js/components/Navigation/utils/navigation-constants.js'

import { types as STOREMODULES } from '@/js/plugins/store/store-modules.js'
// import APP_ACTIONS from '@/js/plugins/store/modules/app/action-types.js'
import APP_GETTER from '@/js/plugins/store/modules/app/getter-types.js'

export default {
  name: 'NavigationStoreModeItem',
  components: {
    IconSelect,
  },
  data() {
    return {
      storeMode: false,
      loading: false,
    }
  },
  computed: {
    ...mapGetters(STOREMODULES.APP, {
      getLinkByType: APP_GETTER.APP_CONFIG_LINK_BY_TYPE,
      appShopModus: APP_GETTER.SHOPMODUS,
      appLogoutUrl: APP_GETTER.LOGOUT_URL,
      appShopmodeUrl: APP_GETTER.SHOPMODE_LOGOUT_URL,
      appUserIsGuest: APP_GETTER.IS_GUEST_SUBUSER,
      usermanagementUrl: APP_GETTER.USERMANAGEMENT_URL,
    }),
    apiUrl() {
      return `${this.usermanagementUrl}/api/impersonate_storemode`
    },
    // csrfTokenUrl() {
    //   return `${this.usermanagementUrl}/api/csrf_token`
    // },
    buttonType() {
      return this.storeMode ? API_CONSTANTS.CTA.TYPES.PRIMARY : API_CONSTANTS.CTA.TYPES.BLACK
    },
    statusClasses() {
      return [
        this.$style.status,
        this.storeMode ? this.$style['status--on'] : this.$style['status--off'],
      ]
    },
  },
  watch: {
    appShopModus: {
      handler() {
        this.storeMode = !!this.appShopModus
      },
      immediate: true,
    },
  },
  methods: {
    async toggleStoreMode() {
      if (!this.storeMode) {
        this.loading = true
        // Security: We need to obtain a new Anti-CSRF-Token first before we can switch to store mode, i.e. send POST impersonation request
        // const csrf_result = await axios.get(this.csrfTokenUrl).catch(error => {
        //   this.loading = false
        //   return Promise.reject(new Error(error.message))
        // })
        // let csrf_token = csrf_result?.data?.csrf_token

        // Finally send actual POST request to switch to store mode, including the new Anti-CSRF-Token as header
        const result = await axios
          .post(
            this.apiUrl,
            // {},
            // {
            //   headers: {
            //     'X-Csrf-Token': csrf_token,
            //   },
            // },
          )
          .catch(error => {
            this.loading = false
            return Promise.reject(new Error(error.message))
          })
        this.loading = false
        if (result.status !== 204) {
          return Promise.reject(new Error(`STOREMODE::Call unsuccessful!`))
        }
        this.$emit(NAV_CONSTANTS.ACTIONS.APP.STORE_MODE_ON)
        this.storeMode = true
        window.location.replace(this.appShopmodeUrl)
      } else {
        this.$emit(NAV_CONSTANTS.ACTIONS.APP.STORE_MODE_OFF)
        this.storeMode = false
        window.location = this.appLogoutUrl
      }
    },
  },
}
</script>

<style lang="scss" module>
.button {
  display: flex;
  align-items: center;
  min-width: 6rem !important;
  padding: 0.25rem 0.5rem;

  border: var(--border-black);
  border-radius: 1.75rem;

  pointer-events: all;
}

.switch {
  pointer-events: none;

  :global(.v-input--switch__thumb) {
    color: var(--primary) !important;
    caret-color: var(--primary) !important;
  }

  :global(.v-input--switch__track) {
    visibility: hidden;
  }

  :global(.v-input--selection-controls__input) {
    margin-right: 0;
  }
}

.switch-wrapper {
  position: relative;

  display: flex;
  align-items: center;
}

.status {
  color: hsla(0, 0%, 0%, 0.3);
  font-size: var(--font-sm);
  line-height: 1;
  text-transform: uppercase;
}

.status--on {
  margin-right: -1rem;

  color: var(--white);
}

.status--off {
  margin-left: -1rem;
}
</style>
